import { render, staticRenderFns } from "./AssociatedStockAdjustments.vue?vue&type=template&id=702367f8&scoped=true&"
import script from "./AssociatedStockAdjustments.vue?vue&type=script&lang=js&"
export * from "./AssociatedStockAdjustments.vue?vue&type=script&lang=js&"
import style0 from "./AssociatedStockAdjustments.vue?vue&type=style&index=0&id=702367f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702367f8",
  null
  
)

export default component.exports